"use client"
import { StoryblokComponentBase } from "@/types/component-types"
import { isStoryblockComponent } from "@/types/type-guards"
import { StoryblokServerComponent } from "@storyblok/react/rsc"
import Richtext from "@ui-library/richtext/Richtext"
import { Fragment, useState } from "react"
import { Button } from "../button/Button"
import Col from "../grid/Col"
import Accordion from "./Accordion"
import AccordionItem from "./AccordionItem"
import { AccordionBasicItem, AccordionSectionProps } from "./AccordionSectionProps"

export const HideableAccordionItem = ({
  section,
  hidden
}: {
  section: StoryblokComponentBase | AccordionBasicItem
  hidden: boolean
}) =>
  isStoryblockComponent(section) ? (
    <StoryblokServerComponent blok={section} hidden={hidden} />
  ) : (
    <AccordionItem value={section.title || ""} title={section.title || ""} hidden={hidden}>
      <Richtext content={section.content} />
    </AccordionItem>
  )

export const TwoColumnsAccordion = ({
  sections = [],
  visibleRowsLimit = 5
}: Pick<AccordionSectionProps, "sections" | "visibleRowsLimit">) => {
  const half = Math.ceil(sections.length / 2)
  const leftColumn = sections.slice(0, half)
  const rightColumn = sections.slice(half)
  const [showMore, setShowMore] = useState(leftColumn.length > Number(visibleRowsLimit))

  return (
    <>
      <Accordion type="single" className="flex w-full flex-col xl:flex-row xl:gap-[1em]">
        <Col className="flex flex-col gap-4" grid={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 6 }}>
          {leftColumn.map((section, index) => (
            <Fragment key={index}>
              <HideableAccordionItem section={section} hidden={showMore && index >= visibleRowsLimit} />
            </Fragment>
          ))}
        </Col>
        <Col className="flex flex-col gap-4" grid={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 6 }}>
          {rightColumn.map((section, index) => (
            <Fragment key={index}>
              <HideableAccordionItem section={section} hidden={showMore && index >= visibleRowsLimit} />
            </Fragment>
          ))}
        </Col>
      </Accordion>
      {showMore ? (
        <Button className="mt-8" onClick={() => setShowMore(false)}>
          Visa mer
        </Button>
      ) : null}
    </>
  )
}
